	function ContactForm(settings){
		this.className			= "ContactForm";

		const state = nav.getState();
		const lang = state.nextParts[0] || "global";

		this.templateBase		= `/${lang}/myverco/forms/`;

		this.name = "contact";

		if(!settings) settings = {};

		settings.link = settings.link ?? false;
		settings.title = settings.title ?? false;
		settings.target = settings.target ?? false;
		settings.submitAnalytics = settings.submitAnalytics ?? true;
		settings.resourceType = settings.resourceType ?? "document";
		settings.values = settings.values ?? false;

		console.log(settings);

		//var CookiesController = Aviator.get('cookiesController');
		// var nav = Aviator.get('nav');

		this.data = {
			pages: [
				{
					name: "details",
					submit: Igloo.delegate(this,function(){

					}),
					init: Igloo.delegate(this,function(){
						// var $check = this.$content.find(".js-checkbox");
						// var $label = $check.parent();
						// var $updates = this.$content.find("[name='updates']");
						//
						// $label.on("click",Igloo.$d(this,function($this){
						// 	$label.toggleClass("checked");
						// 	$updates.val($label.hasClass("checked") ? "Yes" : "No");
						// }));

					}),
					submissionUrl: `/${lang}/myverco/forms/contact`
				},
				{
					name: "complete",
					render: Igloo.delegate(this,function(){

						const v = this.values;

						this.submitHubspot({
							// formId: "b7be605b-09ae-4b26-a543-9626012bd589", // MyVecro Contact Form for testing
							enquiry: "1",
							agree: false,
							message: v['form_message'],
							firstname: v['form_first_name'],
							lastname: v['form_last_name'],
							email: v['form_email'],
							phone: v['form_phone'],
							jobtitle: v['form_job_title'],
							company: v['form_company'],
							industry: v['form_sector'],
							country: v['form_country'],
						});
					}),
				},
			]
		}

		this.setup(settings);
	};
	ContactForm.inheritsFrom( PopupForm );